var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCompanyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.3667V4.66667H4.66667V2H11.7V7.33333H14.3667V14.3667H8.85V11.5167H7.51667V14.3667H2ZM3.51667 12.85H4.85V11.5167H3.51667V12.85ZM3.51667 10.1833H4.85V8.85H3.51667V10.1833ZM3.51667 7.51667H4.85V6.18333H3.51667V7.51667ZM6.18333 10.1833H7.51667V8.85H6.18333V10.1833ZM6.18333 7.51667H7.51667V6.18333H6.18333V7.51667ZM6.18333 4.85H7.51667V3.51667H6.18333V4.85ZM8.85 10.1833H10.1833V8.85H8.85V10.1833ZM8.85 7.51667H10.1833V6.18333H8.85V7.51667ZM8.85 4.85H10.1833V3.51667H8.85V4.85ZM11.5167 12.85H12.85V11.5167H11.5167V12.85ZM11.5167 10.1833H12.85V8.85H11.5167V10.1833Z",
    fill: "#00E864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCompanyIcon);
export default __webpack_public_path__ + "static/media/ActiveCompanyIcon.0cca1f86cff43c2efe2c6caae8ad46b0.svg";
export { ForwardRef as ReactComponent };